import IndustrySelector from '@/components/IndustrySelector/IndustrySelector'
import { Button } from '@/components/ui/Button'
import styles from './registration.module.css'

interface IndustryItem {
  id: string
  name: string
}

interface RegistrationIndustriesFormProps {
  industries: IndustryItem[]
  selected: string[]
  onChange: (ids: string[]) => void
  onNext: () => void
  onBack: () => void
}

const RegistrationIndustriesForm = ({ industries, selected, onChange, onNext, onBack }: RegistrationIndustriesFormProps) => {
  const canProceed = selected.length >= 1 && selected.length <= 3

  return (
    <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
      <p className={styles.textGrey}>
        Select up to <span style={{ color: 'var(--color-brand-40)', fontWeight: 700 }}>3 industries</span> relevant to your interests or
        business.
      </p>

      <IndustrySelector availableIndustries={industries} selectedIndustries={selected} onChange={onChange} maxSelections={3} />

      <div className={styles.buttonGroup}>
        <Button type="button" variant="outline" size="large" style={{ width: '100%' }} className={styles.backBtn} onClick={onBack}>
          Back
        </Button>
        <Button
          type="button"
          variant="fill"
          size="large"
          style={{ width: '100%' }}
          className={styles.submitBtn}
          disabled={!canProceed}
          onClick={onNext}
        >
          Next
        </Button>
      </div>
    </form>
  )
}

export default RegistrationIndustriesForm
